// extracted by mini-css-extract-plugin
module.exports = {"listItem":"gNZTp","list":"_2Hrzv","stats":"_3zD21"};